import firebase from 'firebase/compat/app';
import Economy from 'dt-common/constants/Economy';
import Config from '~/constants/Config';
import { CurrencyDispatcher } from '~/flux/dispatchers';
import mutationInitSteamPurchase from '~/graphql/payments/mutationInitSteamPurchase';
import mutationSteamPurchasePopupClosed from '~/graphql/payments/mutationSteamPurchasePopupClosed';
import { logError } from '~/logger';
import { PaymentsStoreMessage } from '../messages';

export default async function requestInitSteamPurchase(
  {
    playerId,
    emit,
  }: {
    playerId: string | null;
    emit: (message: PaymentsStoreMessage, data?: unknown) => void;
  },
  action: { purchase_selection: { id: string; description: string } }
) {
  if (!playerId) throw new Error('playerId required');

  const steamId64 = (
    await window.steamContext?.getSteamPlayerData()
  )?.steamId.steamId64?.toString();
  if (!steamId64) throw new Error('steamId64 required');

  try {
    const result = await mutationInitSteamPurchase({
      playerId,
      purchaseSelectionId: action.purchase_selection.id,
      platform: Config.PLATFORM,
      steamId64,
      description: action.purchase_selection.description,
    });

    const newWindow = window.open(
      result.steamurl +
        `?returnurl=${encodeURI('https://dungeonteam.com?platform=steam_purchase_redirect')}`,
      'Buy Pixie Dust via Steam',
      'width=800,height=600'
    );

    const intervalId = setInterval(async () => {
      if (!newWindow?.closed) return;
      clearInterval(intervalId);

      try {
        const closeResult = await mutationSteamPurchasePopupClosed({
          playerId,
          orderid: result.orderid,
          transid: result.transid,
          pdAmount: result.pdAmount,
          platform: Config.PLATFORM,
        });

        if (!closeResult.completed) return;

        if (closeResult.currency1 != null) {
          CurrencyDispatcher.handleCurrencyAction({
            actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
            currency1: closeResult.currency1,
          });
        }

        emit('STEAM_PURCHASE_COMPLETE', closeResult);

        if (process.env.DT_TIER === 'production') {
          const productID = `pd_${result.pdAmount}`;
          const item = (Economy.PREMIUM_ITEM_DICT as Record<string, { usd_cents: number }>)[
            productID
          ];
          firebase.analytics().logEvent('purchase', {
            value: item.usd_cents / 100,
            currency: 'USD',
            transaction_id: result.transid ?? result.orderid,
            items: [{ item_id: productID }],
          });
        }
      } catch (err) {
        logError(err, {
          module: 'PaymentsStore',
          func: 'requestInitSteamPurchase/popupClosed',
        });
      }
    }, 100);
  } catch (err) {
    logError(err, {
      module: 'PaymentsStore',
      func: 'requestInitSteamPurchase',
    });
  }
}
